import {withSnackbar} from "react-simple-snackbar";
import React from "react"
import {
    Alert, Badge,
    Button,
    Col, Form,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader, Nav, NavItem, NavLink,
    Row,
    Spinner, TabContent,
    Table, TabPane
} from "reactstrap";
import PaymentMethodModel from "../../../Models/PaymentMethodModel"
import SingleActivePaymentMethod from "./SingleActivePaymentMethod";
import ConfirmationModalAlert from "../../../Components/ModalAlerts/ConfirmationModalAlert";
import InputWithIcon from "../../../Elements/InputWithIcon";
import GlSelect from "../../../Components/GlSelect";
import ClientModel from "../../../Models/ClientModel";
import {Banks, getBankObject} from "../../../Banks";
import MethodSettings from "./MethodSettings";
import Select from "react-select";
import {GetTitle} from "../../../Routes/AdminRoute";
import {ApiErrorThrow} from "../../../Config";
import PaymentMethodSelect from "../../../Elements/PaymentMethodSelect";
import CustomCheckbox from "../../../Elements/CustomCheckbox";
import {Card, CardHeader} from "@material-ui/core";
import classnames from "classnames";
import {AiOutlineTable, BiMessageSquareAdd, FiSettings, VscSearchStop} from "react-icons/all";
import StaticPanelTopBar from "../../../Components/StaticPanelTopBar";
import {Skeleton} from "@material-ui/lab";
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import {react_intl} from "../../../index";
import ButtonLoad from "../../../Elements/ButtonLoad";

const defaultMethodSettings = {
    name: "",
    description: "",
    is_default: false,
    settings: []
}

const RateInput = (props) => {
    return <input
        onBlur={(e) => {
            e.target.value = (e.target.value).replaceAll(",", ".")
            if (e.target.value === "")
                e.target.value = 0
            if (e.target.value)
                e.target.value = parseFloat(e.target.value).toFixed(2)
            if (typeof props.onChange === "function")
                props.onChange(e)
        }}
        {...props}
    />
}
const ExtraInstallmentInput = (props) => {
    return <input
        onBlur={(e) => {
            e.target.value = (e.target.value).match(/\d+/) !== null ? (e.target.value).match(/\d+/)[0] : ""
            if (e.target.value)
                e.target.value = parseInt(e.target.value)

            if (typeof props.onChange === "function")
                props.onChange(e)
        }}
        {...props}
    />
}

const MethodsSkeleton = (props) => {
    return <div>
        <Row>
            {[0, 1, 2].map((item, i) => <Col key={`Skeleton-${i}`}>
                <div className={"border p-3 w-100 rounded"}>
                    <Row className={"w-100"}>
                        <Col lg={2} className={"text-center"}>
                            <Skeleton variant={"circle"} width={32} height={32}/>
                        </Col>
                        <Col lg={7}>
                            <Skeleton variant={"text"} width={"100%"} height={32}/>
                        </Col>
                        <Col lg={3}>
                        </Col>
                    </Row>
                    <div className={""}>
                        <Skeleton variant={"text"} width={"100%"} height={25} className={"mb-1"}/>
                        <Skeleton variant={"text"} width={"100%"} height={25}/>
                    </div>
                    <div className={"mt-2 text-center pt-2 border-top"}>
                        <Skeleton variant={"rect"} className={"rounded d-inline-block mr-1 float-none"} width={120}
                                  height={32}/>
                        <Skeleton variant={"rect"} className={"rounded d-inline-block float-none"} width={120}
                                  height={32}/>
                    </div>
                </div>
            </Col>)}
        </Row>
    </div>
}

class InstallmentRow extends React.Component {
    render() {
        let {props} = this
        let {extraInstallmentChanged, rateChanged} = props

        let activated = (props.installmentRate !== null)

        return <tr valign={"middle"}>
            <th><CustomCheckbox
                onChange={e => {
                    if (typeof e.target.checked === "boolean" && !e.target.checked) {
                        rateChanged(null);
                    }
                    else
                        rateChanged("0.00")
                }}
                checked={activated} label={props.title}/></th>
            <td>
                <RateInput
                    className={!activated ? "rate-input disabled" : "rate-input"}
                    disabled={!activated}
                    type={"text"} value={!activated ? "" : props.installmentRate}
                    name={`${props.number}installments`}
                    onChange={(e) => rateChanged(e.target.value)}
                />
            </td>
            <td>
                <ExtraInstallmentInput
                    className={!activated ? "extra-installment-input disabled" : "extra-installment-input"}
                    disabled={!activated}
                    type={"number"} min={1} name={`${props.number}installments_additional`}
                    onChange={(e) => extraInstallmentChanged(e.target.value)}
                />
            </td>
        </tr>
    }
}

class Methods extends React.Component {
    defaultState = {
        activeMethodName: "",
        activeMethodDescription: "",
        activeMethodSettings: [],
        methodEditModal: false,
        activeMethods: [],
        modalInstallment: false,
        settingTab: "settings",
        saving: false
    }
    state = {
        activeMethods: [],
        methodSelected: {},
        deleteModalOpen: false,
        changeId: null,
        methodEditModal: false,
        activeMethodSettings: [],
        activeMethodClass: "",
        activeMethodName: "",
        activeMethodDescription: "",
        addMethodModal: false,
        createMethodStep: 1,
        createMethodClass: "",
        createMethodClassTemp: "",
        modalInstallment: false,
        activeInstallments: {},
        methodFilter: "",
        methodsLoading: true,
        settingTab: "settings",
        saving: false,
        createLoading: false,
        deleteLoading: false
    }

    settingTabChange = (newTab) => {
        this.setState({
            settingTab: newTab
        })
    }

    methodFilterHandle = (e) => {
        this.setState({
            methodFilter: e.target.value
        })
    }

    constructor(props) {
        super(props);
        this.loadActiveMethods()
        this.modalInstallmentToggle = this.modalInstallmentToggle.bind(this)
        this.deleteModalToggle = this.deleteModalToggle.bind(this)
        this.methodEditModalToggle = this.methodEditModalToggle.bind(this)
        this.addMethodModalToggle = this.addMethodModalToggle.bind(this)
        this.methodHandler = this.methodHandler.bind(this)
        this.methodFilterHandle = this.methodFilterHandle.bind(this)
        this.settingTabChange = this.settingTabChange.bind(this)
        let self = this
    }


    addMethodModalToggle = (e) => {
        this.setState({
            createMethodClass: "",
            createMethodClassTemp: "",
            addMethodModal: !this.state.addMethodModal,
            createMethodStep: 1
        })
    }

    methodEditModalToggle = (details) => {
        if (typeof details === "undefined" || details === null)
            details = {}

        let settings = details.settings
        if (typeof settings === "undefined" || settings === null)
            settings = []

        settings = settings.filter(item => (item.name).endsWith("installments"))

        let installments = {}
        settings.map(item => {
            if(item.value!=="" && typeof item.value !== "undefined" && item.value !== null)
                installments[item.name] = parseFloat(item.value).toFixed(2)
            else
                installments[item.name] = null

        })

        this.setState({
            methodEditModal: !this.state.methodEditModal
        }, () => {
            let self = this
            setTimeout(function () {
                self.setState({
                    methodSelected: details,
                    activeMethodSettings: details.settings || [],
                    activeMethodClass: details.class,
                    activeMethodName: details.name,
                    activeMethodDescription: details.description,
                    activeInstallments: installments
                })
            }, this.state.methodEditModal ? 0 : 300)
        })
    }
    modalInstallmentToggle = (details) => {
        let settings = details.settings
        if (typeof settings === "undefined" || settings === null)
            settings = []

        settings = settings.filter(item => (item.name).endsWith("installments"))

        let installments = {}
        settings.map(item => {
            if(item.value!=="" && typeof item.value !== "undefined" && item.value !== null)
                installments[item.name] = parseFloat(item.value).toFixed(2)
            else
                installments[item.name] = null
        })

        this.setState({
            modalInstallment: !this.state.modalInstallment
        }, () => {
            let self = this
            setTimeout(function () {
                self.setState({
                    methodSelected: details,
                    activeMethodSettings: details.settings || [],
                    activeMethodClass: details.class,
                    activeMethodName: details.name,
                    activeMethodDescription: details.description,
                    activeInstallments: installments
                })
            }, this.state.modalInstallment ? 0 : 300)
        })
    }

    deleteModalToggle = (details) => {
        this.setState({
            methodSelected: details || {},
            deleteModalOpen: !this.state.deleteModalOpen
        })
    }

    loadActiveMethods = () => {
        this.setState({activeMethods: [], methodsLoading: true})
        PaymentMethodModel.getActiveMethods(['settings']).then(r => r.json())
            .then(r => {
                let data = r.data
                let {settings} = r.included
                data.forEach((item, key) => {
                    if (typeof settings[item.id] === "object") {
                        data[key]['attributes']['settings'] = settings[item.id]
                    }
                })
                this.setState({
                    activeMethods: data,
                    methodsLoading: false,
                    deleteLoading: false
                })
            })
    }

    methodHandler = (e) => {
        let state = {}
        state[e.target.name] = e.target.value
        this.setState(state)
    }

    componentDidMount() {
        document.title = GetTitle(react_intl.formatMessage({id: "admin.payment.methods.title"}))
    }

    render() {
        let bankDetails = {}, bankClass
        let {openSnackbar} = this.props
        let {
            activeMethods,
            methodSelected,
            activeMethodSettings,
            activeMethodClass,
            activeInstallments,
            methodsLoading
        } = this.state

        if (Object.keys(methodSelected).length)
            bankClass = methodSelected.class

        if (this.state.createMethodStep === 2 && this.state.createMethodClass)
            bankClass = this.state.createMethodClass

        else if (typeof activeMethodClass === "string")
            bankClass = activeMethodClass

        if (bankClass)
            bankDetails = getBankObject(bankClass)

        let activeBankSettings = typeof bankDetails.settings === "object" && bankDetails.settings !== null ? bankDetails.settings : {}
        activeBankSettings['convert_currency_on_transaction'] = {
            title: react_intl.formatMessage({id: "admin.payment.methods.covert_on_payment"}),
            description: react_intl.formatMessage({id: "admin.payment.methods.covert_on_payment_desc"}),
            type: "currency",
            value: "",
            default: ""
        }

        let activeBankInstallments = typeof bankDetails.installments === "object" && bankDetails.installments !== null ? bankDetails.installments : []

        let filtered_banks = Object.keys(Banks)
            .filter(e => {
                if (this.state.methodFilter === "")
                    return true
                let item = Banks[e]
                return ((item.name).toLowerCase()).indexOf(this.state.methodFilter) > -1
            })

        return <div>
            <StaticPanelTopBar
                title={<FormattedMessage id={"admin.payment.methods.active_methods"}/>}
                extra={<div className={"text-right padding-top-25"}>
                    <Link
                        to={'/admin/payment-rules'}
                        className={"btn btn-secondary mr-2"}
                        onClick={this.addMethodModalToggle}><FormattedMessage id={"admin.payment.methods.edit_rules"}/>
                        {" "}
                        <i
                            className={"icon-feather-edit"}/></Link>
                    <Button
                        onClick={this.addMethodModalToggle}
                        color={"primary"}><FormattedMessage id={"admin.payment.methods.add_new"}/> <i
                        className={"icon-feather-plus"}/></Button>
                </div>}
            />
            <div className="dashboard-box p-3 margin-top-100 margin-bottom-10">

                <Modal isOpen={this.state.addMethodModal} toggle={this.addMethodModalToggle}
                       size={"lg"}
                       centered={true}
                       returnFocusAfterClose={false}
                >
                    <ModalHeader toggle={this.addMethodModalToggle}>
                        <FormattedMessage id={"admin.payment.methods.add_modal_title"}/>
                        <Badge>{`${this.state.createMethodStep}/2`}</Badge>
                    </ModalHeader>
                    <ModalBody>
                        {this.state.createMethodStep === 1 &&
                        <div className={"padding-bottom-25 padding-left-25 padding-right-25"}>
                            <Row className={"bg-light padding-top-10"}>
                                <Col sm={12} md={7}>
                                    <h4 style={{lineHeight: "38px"}}><FormattedMessage
                                        id={"admin.payment.methods.select_gateway"}/></h4>
                                </Col>
                                <Col sm={12} md={{size: 5}}>
                                    <Input
                                        style={{width: "calc(100% - 30px)"}}
                                        className={"float-left"}
                                        onChange={this.methodFilterHandle} type="text"/>
                                    <i className={"icon-feather-search float-right text-center"} style={{
                                        width: 30,
                                        lineHeight: "35px"
                                    }}/>
                                </Col>
                            </Row>

                            <Row className={"padding-top-25"}>{filtered_banks.length ? filtered_banks.map((key, i) => {
                                let item = Banks[key]
                                let e = {
                                    label: item.name,
                                    value: key
                                }
                                let selected = e.value === this.state.createMethodClassTemp
                                return <Col sm={6} lg={3} className={"mb-3"} key={`Method-${i}`}>
                                    <Card
                                        style={{
                                            cursor: "pointer"
                                        }}
                                        className={classnames("new-payment-method-box", {"selected": selected})}
                                        onClick={clc => this.setState({createMethodClassTemp: e.value}, () => {
                                            let _bankObject = getBankObject(e.value)
                                            let settings = []
                                            if (typeof _bankObject.settings === "object") {
                                                let item = null
                                                Object.keys(_bankObject.settings).forEach(key => {
                                                    item = _bankObject.settings[key]
                                                    settings.push({
                                                        name: key,
                                                        value: typeof item.default !== "undefined" ? item.default : ""
                                                    })
                                                    this.setState({
                                                        activeMethodSettings: settings
                                                    })
                                                })
                                            }
                                        })}>
                                        <div style={{
                                            textAlign: "center",
                                            width: "100%",
                                            height: 70,
                                            background: `url('${(item.image || {}).default}') no-repeat center`,
                                            backgroundSize: "auto 125px",
                                            backgroundPosition: "center center"
                                        }}>
                                        </div>
                                        <CardHeader
                                            className={classnames("text-center border-top p-2", {
                                                "bg-light": !selected,
                                                "bg-dark text-white": selected
                                            })}
                                            style={{height: 50}}
                                            disableTypography
                                            title={item.name}
                                        />
                                    </Card>
                                </Col>
                            }) : <h4 className={"text-center w-100"}><i className={"icon-line-awesome-ban"}/>
                                <FormattedMessage id={"admin.payment.methods.no_any_gateway"}/></h4>}</Row>
                        </div>}
                        {this.state.createMethodStep === 2 && <>
                            <Table className={""}>
                                <tbody>
                                {activeBankSettings ? Object.keys(activeBankSettings).map(key => {
                                    let item = activeBankSettings[key]
                                    return <MethodSettings
                                        settingKey={key}
                                        value={(activeMethodSettings.find(item => item.name === key) || {}).value}
                                        details={item}
                                        handler={this.methodSettingHandler}
                                    />
                                }) : ""}
                                </tbody>
                            </Table>
                        </>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            onClick={() => {
                                this.setState({
                                    createMethodClassTemp: "",
                                    createMethodStep: 1
                                })
                            }}
                            color={"info"}
                            className={"float-left"}><i className={"icon-feather-arrow-left"}/> <FormattedMessage
                            id={"admin.payment.methods.back"}/></Button>
                        <ButtonLoad
                            onClick={() => {
                                if (this.state.createMethodStep === 1) {
                                    let temp = this.state.createMethodClassTemp
                                    this.setState({
                                        createMethodClass: temp,
                                        createMethodClassTemp: "",
                                        createMethodStep: 2
                                    })
                                }
                                if (this.state.createMethodStep === 2) {
                                    this.setState({createLoading: true})
                                    PaymentMethodModel.create({
                                        name: Banks[this.state.createMethodClass].name,
                                        description: Banks[this.state.createMethodClass].name,
                                        settings: this.state.activeMethodSettings,
                                        class: this.state.createMethodClass
                                    }).then(r => r.json()).then(r => {
                                        openSnackbar(react_intl.formatMessage({id: "admin.payment.methods.added"}));
                                        this.setState({createLoading: false})
                                        this.addMethodModalToggle()
                                        this.loadActiveMethods()
                                    })
                                }
                            }}
                            disabled={this.state.createMethodClass < 2 && this.state.createMethodClassTemp === ""}
                            color={"primary"}
                            text={this.state.createMethodStep === 2 ? react_intl.formatMessage({id: "admin.payment.methods.next"}) : react_intl.formatMessage({id: "admin.payment.methods.next"})}
                            loading={this.state.createLoading}
                        />
                    </ModalFooter>
                </Modal>

                <ConfirmationModalAlert
                    title={react_intl.formatMessage({id: "admin.payment.methods.delete_title"})}
                    isOpen={this.state.deleteModalOpen}
                    buttonLoading={this.state.deleteLoading}
                    toggle={this.deleteModalToggle}
                    icon={"icon-feather-alert-circle"}
                    buttonAction={() => {
                        if (!this.state.changeId) {
                            openSnackbar(react_intl.formatMessage({id: "admin.payment.methods.select_alternative"}));
                            return false;
                        }
                        this.setState({
                            deleteLoading: true
                        })
                        PaymentMethodModel.delete(this.state.methodSelected.id, this.state.changeId).then(() => {
                            openSnackbar(react_intl.formatMessage({id: "admin.payment.methods.deleted"}))
                            this.loadActiveMethods()
                            this.deleteModalToggle()
                        }).catch(r => ApiErrorThrow(r, openSnackbar))
                    }}
                >
                    <Alert><i
                        className={"icon-line-awesome-exclamation-triangle"}/>
                        <FormattedMessage id={"admin.payment.methods.alert_message"} values={
                            {
                                name: this.state.methodSelected.name
                            }
                        }/></Alert>
                    <p><FormattedMessage id={"admin.payment.methods.alert_message_desc"}/></p>
                    <div className={"text-left"}>
                        <PaymentMethodSelect
                            placeholder={react_intl.formatMessage({id: "admin.payment.methods.alternative_placeholder"})}
                            isMulti={false}
                            onChange={(e) => {
                                this.setState({changeId: e.value})
                            }}
                        />
                    </div>
                </ConfirmationModalAlert>

                <Modal isOpen={this.state.methodEditModal} toggle={this.methodEditModalToggle} size={"lg"}
                       returnFocusAfterClose={false}
                       onClosed={() => {
                           this.setState({settingTab: 'settings'})
                       }
                       }>
                    <ModalHeader
                        toggle={this.methodEditModalToggle}>{react_intl.formatMessage({id: "admin.payment.methods.edit_modal_title"}, {name: this.state.methodSelected.name})}
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={3}>
                                <Nav pills={true} vertical={true}>
                                    <NavItem onClick={() => this.settingTabChange('settings')}>
                                        <NavLink href={"#"}
                                                 active={this.state.settingTab === "settings"}><FiSettings/>
                                            {" "}<FormattedMessage
                                                id={"admin.payment.methods.edit_modal.settings"}/></NavLink>
                                    </NavItem>
                                    <NavItem
                                        className={classnames({
                                            "d-none": this.state.activeMethodClass === null || this.state.activeMethodClass === "" ||
                                                (getBankObject(this.state.activeMethodClass) || {}).installments === null
                                        })}
                                        onClick={() => this.settingTabChange('installment')}>
                                        <NavLink href={"#"}
                                                 active={this.state.settingTab === "installment"}> <AiOutlineTable/>
                                            {" "}<FormattedMessage
                                                id={"admin.payment.methods.edit_modal.installment"}/></NavLink>
                                    </NavItem>
                                </Nav>
                            </Col>
                            <Col lg={9}>
                                <TabContent activeTab={this.state.settingTab}>
                                    <TabPane tabId={"settings"}>
                                        <Row>
                                            <Col>
                                                <Label className={"w-100"}>
                                                    <FormattedMessage id={"admin.payment.methods.edit_modal.name"}/>
                                                    <InputWithIcon type={"text"}
                                                                   className={"w-100"}
                                                                   name={"activeMethodName"}
                                                                   value={this.state.activeMethodName}
                                                                   onChange={this.methodHandler}
                                                    />
                                                </Label>
                                            </Col>
                                            <Col>
                                                <Label className={"w-100"}>
                                                    <FormattedMessage id={"admin.payment.methods.edit_modal.desc"}/>
                                                    <InputWithIcon type={"text"} name={"activeMethodDescription"}
                                                                   value={this.state.activeMethodDescription}
                                                                   onChange={this.methodHandler}
                                                    />
                                                </Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12}>
                                                <Label><i className={"icon-line-awesome-cogs"}/> <FormattedMessage
                                                    id={"admin.payment.methods.edit_modal.settings"}/></Label>
                                            </Col>
                                            <Table className={""}>
                                                <tbody>
                                                {activeBankSettings ? Object.keys(activeBankSettings).map((key,counter) => {
                                                    let item = activeBankSettings[key]
                                                    return <MethodSettings
                                                        z_index_value={999-counter}
                                                        settingKey={key}
                                                        id={methodSelected.id}
                                                        value={(activeMethodSettings.find(item => item.name === key) || {}).value}
                                                        details={item} handler={this.methodSettingHandler}/>
                                                }) : ""}
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId={"installment"}>
                                        <table className={"table table-striped w-100 installment-table text-center"}
                                               cellSpacing={5} cellPadding={5} border={0}>
                                            <thead>
                                            <tr valign={"middle"}>
                                                <th width={"30%"} align={"right"}><FormattedMessage
                                                    id={"admin.payment.methods.edit_modal.installment_count"}/></th>
                                                <th width={"40%"}><FormattedMessage
                                                    id={"admin.payment.methods.edit_modal.installment_rate"}/></th>
                                                <th width={"30%"}><FormattedMessage
                                                    id={"admin.payment.methods.edit_modal.installment_extra"}/></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {activeBankInstallments ? Object.keys(activeBankInstallments).map((key, i) => {
                                                let item = activeBankInstallments[key]
                                                let count = i + 2
                                                return <InstallmentRow
                                                    rateChanged={(val) => {
                                                        let installments_copy = {...activeInstallments}
                                                        installments_copy[`${count}installments`] = val;
                                                        this.setState({
                                                            activeInstallments: installments_copy
                                                        })
                                                    }}
                                                    extraInstallmentChanged={(val) => {
                                                        let installments_copy = {...activeInstallments}
                                                        installments_copy[`${count}installments_extra`] = val;
                                                        this.setState({
                                                            activeInstallments: installments_copy
                                                        })
                                                    }}
                                                    title={item.title}
                                                    number={count}
                                                    installmentRate={typeof activeInstallments[`${count}installments`] !== "undefined" && activeInstallments[`${count}installments`] !== "" ? activeInstallments[`${count}installments`] : ""}
                                                    extraInstallment={typeof activeInstallments[`${count}installments_extra`] !== "undefined" && activeInstallments[`${count}installments_extra`] !== "" ? activeInstallments[`${count}installments_extra`] : ""}
                                                />
                                            }) : ""}
                                            </tbody>
                                        </table>
                                    </TabPane>
                                </TabContent>
                            </Col>
                        </Row>
                    </ModalBody>

                    <ModalFooter>
                        <ButtonLoad
                            style={{zIndex:0}}
                            onClick={() => this.save()}
                            color={"primary"}
                            loading={this.state.saving}
                            text={react_intl.formatMessage({id: "admin.payment.methods.edit_modal.save"})}
                        />
                    </ModalFooter>
                </Modal>

                {/*<Modal isOpen={this.state.modalInstallment} toggle={this.modalInstallmentToggle} size={"md"}>*/}
                {/*    <ModalHeader*/}
                {/*        toggle={this.modalInstallmentToggle}>{`"${this.state.methodSelected.name}" - Taksit Ayarları`}</ModalHeader>*/}
                {/*    <ModalBody>*/}
                {/*        <Row>*/}
                {/*            <Col>*/}
                {/*                <table className={"table table-striped w-100 installment-table text-center"}*/}
                {/*                       cellSpacing={5} cellPadding={5} border={0}>*/}
                {/*                    <thead>*/}
                {/*                    <tr valign={"middle"}>*/}
                {/*                        <th width={"30%"} align={"right"}>Taksit Adedi</th>*/}
                {/*                        <th width={"40%"}>Oran</th>*/}
                {/*                        <th width={"30%"}>Artı Taksit</th>*/}
                {/*                    </tr>*/}
                {/*                    </thead>*/}
                {/*                    <tbody>*/}
                {/*                    {activeBankInstallments ? Object.keys(activeBankInstallments).map((key, i) => {*/}
                {/*                        let item = activeBankInstallments[key]*/}
                {/*                        let count = i + 2*/}
                {/*                        return <InstallmentRow*/}
                {/*                            rateChanged={(val) => {*/}
                {/*                                let installments_copy = {...activeInstallments}*/}
                {/*                                installments_copy[`${count}installments`] = val;*/}
                {/*                                this.setState({*/}
                {/*                                    activeInstallments: installments_copy*/}
                {/*                                })*/}
                {/*                            }}*/}
                {/*                            extraInstallmentChanged={(val) => {*/}
                {/*                                let installments_copy = {...activeInstallments}*/}
                {/*                                installments_copy[`${count}installments_extra`] = val;*/}
                {/*                                this.setState({*/}
                {/*                                    activeInstallments: installments_copy*/}
                {/*                                })*/}
                {/*                            }}*/}
                {/*                            title={item.title}*/}
                {/*                            number={count}*/}
                {/*                            installmentRate={typeof activeInstallments[`${count}installments`] !== "undefined" && activeInstallments[`${count}installments`] !== "" ? activeInstallments[`${count}installments`] : ""}*/}
                {/*                            extraInstallment={typeof activeInstallments[`${count}installments_extra`] !== "undefined" && activeInstallments[`${count}installments_extra`] !== "" ? activeInstallments[`${count}installments_extra`] : ""}*/}
                {/*                        />*/}
                {/*                    }) : ""}*/}
                {/*                    </tbody>*/}
                {/*                </table>*/}
                {/*            </Col>*/}
                {/*        </Row>*/}
                {/*    </ModalBody>*/}
                {/*    <ModalFooter>*/}
                {/*        <Button*/}
                {/*            onClick={() => {*/}
                {/*                this.saveInstallments()*/}
                {/*            }}*/}
                {/*            color={"primary"}>Kaydet</Button>*/}
                {/*    </ModalFooter>*/}
                {/*</Modal>*/}

                <div className={"text-center w-100"}>
                    {methodsLoading && <MethodsSkeleton/>}
                    {!methodsLoading && <Row className={"pt-0"}>
                        {activeMethods.length ? activeMethods.map(item => <SingleActivePaymentMethod
                            reload={this.loadActiveMethods}
                            details={item}
                            editToggle={this.methodEditModalToggle}
                            editInstallmentToggle={this.modalInstallmentToggle}
                            deleteToggle={this.deleteModalToggle}
                        />) : <>
                            <h3><VscSearchStop size={48}/></h3>
                            <FormattedMessage id={"admin.payment.methods.no_active"} tagName={"h3"}/>
                            <FormattedMessage id={"admin.payment.methods.no_active_desc"} tagName={"p"}/>
                            <Button onClick={this.addMethodModalToggle}><FormattedMessage
                                id={"admin.payment.methods.start_first"}/> <BiMessageSquareAdd/></Button>
                        </>}
                    </Row>}
                </div>
            </div>
        </div>;
    }


    methodSettingHandler = (e) => {
        if (e

                .target
                .type
            ===
            "checkbox"
        )
            e
                .target
                .value = e.target.checked ? "on" : "off"
        let
            state = this.state.activeMethodSettings
        let
            _name = e.target.name
        let
            _value = e.target.value
        let
            exists = false
        state = state.map(item => {
            if (item.name === _name) {
                item.value = _value
                exists = true
            }
            return item
        })

        if (

            !
                exists
        )
            state
                .push({
                    name: _name,
                    value: _value
                })

        this
            .setState({
                activeMethodSettings: state
            })
    }

    findWithAttr(array, attr, value) {
        for (let i = 0; i < array.length; i += 1) {
            if (array[i][attr] === value) {
                return i;
            }
        }
        return -1;
    }

    save = () => {
        let {openSnackbar} = this.props, _class = this.state.activeMethodClass
        let {activeInstallments, activeMethodSettings} = this.state
        this.setState({saving: true})
        let settings = Object.assign([], activeMethodSettings)
        if (typeof activeInstallments === "object") {
            Object.keys(activeInstallments).forEach(item => {
                let indexOfSetting = this.findWithAttr(settings, 'name', item)
                if (indexOfSetting === -1)
                    settings.push({
                        name: item,
                        value: activeInstallments[item]
                    })
                else
                    settings[indexOfSetting].value = activeInstallments[item]
            })
        }

        let details = {
            "name": this.state.activeMethodName,
            "description": this.state.activeMethodDescription,
            "settings": settings
        }
        PaymentMethodModel.saveSettings(this.state.methodSelected.id, details)
            .then(item => {
                this.setState(this.defaultState, this.loadActiveMethods)
            }).catch(r => ApiErrorThrow(r, openSnackbar))
    }

    // saveInstallments = () => {
    //     let {openSnackbar} = this.props
    //     let {activeInstallments, methodSelected} = this.state
    //     PaymentMethodModel.saveSettings(methodSelected.id, {
    //         settings: activeInstallments
    //     }).then(r => {
    //         this.setState(this.defaultState, this.loadActiveMethods)
    //     }).catch(r => ApiErrorThrow(r, openSnackbar))
    // }

}

export default withSnackbar(Methods)